//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React, { useCallback, useState, useEffect } from 'react';
import { format } from 'date-fns';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import Picker from 'react-mobile-picker';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import Button from 'src/onboarding/components/ui/button/Button';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import { Caption } from 'src/onboarding/components/typography/Caption/Caption';

const today = new Date();
const currentYear = today.getFullYear();
const currentMonth = today.getMonth() + 1;
const currentDay = today.getDate();

function getYearsArray() {
  return Array.from({ length: 128 }, (_, i) => (currentYear + i).toString());
}

function getMonthsArray(year) {
  return Array.from({ length: 12 }, (_, i) => {
    const month = i + 1;
    return String(month).padStart(2, '0');
  }).filter(Boolean);
}

function getDayArray(year, month) {
  const dayCount = new Date(year, month, 0).getDate();
  return Array.from({ length: dayCount }, (_, i) => {
    const day = i + 1;
    return String(day).padStart(2, '0');
  }).filter(Boolean);
}

function Page() {
  const when = useStore((state) => state.when);
  const setWhen = useStore((state) => state.setWhen);
  const motivation = useStore((state) => state.motivation);
  const loosGoal = useStore((state) => state.loosGoal);

  const [formattedDate, setFormattedDate] = useState(format(new Date(), 'dd MMM yyyy'));
  const [pickerValue, setPickerValue] = useState(when);
  const { onNext, onPrev, currentIndex } = useNav();

  const [errorMessage, setErrorMessage] = useState('');
  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
    if (!when?.year || !when?.month || !when?.day) return;

    const selectedDate = new Date(when.year, when.month - 1, when.day);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (selectedDate < today) {
      setErrorMessage(t('onboarding.when.errorMessage'));
      setIsDisabled(true);
    } else {
      setErrorMessage('');
      setIsDisabled(false);
    }
  }, [when]);

  useEffect(() => {
    const handleTouchMove = (event: TouchEvent) => {
      if (document.querySelector('.data-picker_new')?.contains(event.target as Node)) {
        event.preventDefault();
      }
    };

    document.addEventListener('touchmove', handleTouchMove, { passive: false });

    return () => {
      document.removeEventListener('touchmove', handleTouchMove);
    };
  }, []);

  const monthsArray = [
    t('onboarding.common.calendar.January'),
    t('onboarding.common.calendar.February'),
    t('onboarding.common.calendar.March'),
    t('onboarding.common.calendar.April'),
    t('onboarding.common.calendar.May'),
    t('onboarding.common.calendar.June'),
    t('onboarding.common.calendar.July'),
    t('onboarding.common.calendar.August'),
    t('onboarding.common.calendar.September'),
    t('onboarding.common.calendar.October'),
    t('onboarding.common.calendar.November'),
    t('onboarding.common.calendar.December'),
  ];

  const getMotivationQuestion = () => {
    switch (motivation) {
      case 'Vacation':
        return t('onboarding.when.options.vacation');
      case 'Wedding':
        return t('onboarding.when.options.wedding');
      case 'Sport':
        return t('onboarding.when.options.sport');
      case 'Summer':
        return t('onboarding.when.options.summer');
      case 'School':
        return t('onboarding.when.options.school');
      case 'Party':
        return t('onboarding.when.options.party');
      case 'Pregnant':
        return t('onboarding.when.options.pregnant');
      default:
        return t('onboarding.when.title');
    }
  };

  const handlePickerChange = useCallback((newValue) => {
    let { year, month, day } = newValue;
    year = Number(year);
    month = Number(month);
    day = Number(day);

    const selectedDate = new Date(year, month - 1, day);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (selectedDate < today) {
      setErrorMessage(t('onboarding.when.errorMessage'));
      setIsDisabled(true);
    } else {
      setErrorMessage('');
      setIsDisabled(false);
    }

    setPickerValue({
      year: String(year),
      month: String(month).padStart(2, '0'),
      day: String(day).padStart(2, '0'),
    });

    setWhen({
      year: String(year),
      month: String(month).padStart(2, '0'),
      day: String(day).padStart(2, '0'),
    });

    setFormattedDate(format(selectedDate, 'dd MMM yyyy'));
  }, []);

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{getMotivationQuestion()}</Title>
        <Text size='m' medium className={'description'}>
          {loosGoal === 'Maintain weight and get fit'
            ? t('onboarding.when.subTitleWithoutWeightLoss')
            : t('onboarding.when.subTitle')}
        </Text>
      </div>
      <div className={'picker-wrapper'}>
        <Picker
          value={pickerValue}
          onChange={handlePickerChange}
          wheelMode='natural'
          height={150}
          className={'data-picker_new'}
          itemHeight={40}
        >
          <Picker.Column name='year' className='col'>
            {getYearsArray().map((year) => (
              <Picker.Item key={year} value={year} className='item'>
                {({ selected }) => (
                  <div className={selected ? 'item_selected' : 'item_neutral'}>{year}</div>
                )}
              </Picker.Item>
            ))}
          </Picker.Column>

          <Picker.Column name='month' className='col'>
            {getMonthsArray(Number(pickerValue.year)).map((month, index) => (
              <Picker.Item key={month} value={month} className='month-item'>
                {({ selected }) => (
                  <div className={selected ? 'item_selected' : 'item_neutral'}>
                    {monthsArray[Number(month) - 1]}
                  </div>
                )}
              </Picker.Item>
            ))}
          </Picker.Column>

          <Picker.Column name='day' className='col'>
            {getDayArray(Number(pickerValue.year), Number(pickerValue.month)).map((day) => (
              <Picker.Item key={day} value={day} className='item'>
                {({ selected }) => (
                  <div className={selected ? 'item_selected' : 'item_neutral'}>{day}</div>
                )}
              </Picker.Item>
            ))}
          </Picker.Column>
        </Picker>
        {errorMessage && (
          <Caption size='m' medium className={'error-message'}>
            {errorMessage}
          </Caption>
        )}
      </div>

      <div className={'next-wrapper'}>
        <Button
          className={isDisabled && 'disabled'}
          title={t('onboarding.when.continue')}
          onClick={() => {
            if (isDisabled) return;
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'when',
              answer: when,
            });
            onNext();
          }}
        />
      </div>
    </div>
  );
}

export default Page;
